export default __webpack_public_path__ + "static/media/applepay.04030e66.svg";